import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CoyResource } from "../../Resources";
import { ShowAlert } from "../utils/alerts";
import { Hide } from "../utils/hide";
import { Form } from "./form";

const Setup = () => {
    document.title = "System Setup";
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [alert, setAlert] = useState({});
    const [complete, setComplete] = useState(false);
    const status = ["Active"];

    const handleInput = (e) => {
        setAlert();
        const n = e.target.name;
        const v = e.target.value;
        switch (n) {
            case "photo":
                const file = e.target.files[0];
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function (e) {
                    setData(values => ({ ...values, preview: reader.result }));
                };
                setData(values => ({ ...values, [n]: file }));

                break;
            default:
                setData(values => ({ ...values, [n]: v }));
                break;
        }
    }
    const handleSubmit = () => {
        setAlert();
        const formData = new FormData();
        for (const [key, val] of Object.entries(data)) {
            if (key === "photo" && val.name) {
                formData.append(key, val, val.name)
            } else {
                formData.append(key, val)
            }
        }
        CoyResource.setup(formData, r => {
            if (r.status) {
                setComplete(true);
                setAlert(r?.body);
            } else {
                setAlert(r?.body);
            }
        });
    }
    return (

        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-9 col-lg-12 col-xl-10">
                    <div className="card shadow-lg o-hidden border-0 my-5">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h4 className="text-dark mb-4">System Setup</h4>
                                        </div>
                                        <Hide state={!complete}>
                                            <ShowAlert alerts={alert} tag="msg" type="success" />
                                            <button onClick={() => navigate("/sign-in")} className="btn btn-primary d-block btn-user w-100">Goto Login</button>
                                        </Hide>
                                        <Hide state={complete}>
                                            <Form onChange={handleInput} data={data} setup={true} alert={alert} status={status} />
                                            <button onClick={handleSubmit} className="btn btn-primary d-block btn-user w-100">Begin Setup</button>
                                        </Hide>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}

export default Setup;